import { useMemo } from 'react';
import { PAYMENT_GATEWAY, type PaymentTransactionType } from '../../types/enums';
import { useKapopay } from './useKapopay';
import { usePay2Local } from './usePay2Local';
import { useLigdiCash } from './useLigdiCash';
import { useMarketplaceConfig } from '../../queries/marketplace';
import { useCrypto } from './useCrypto';

export const usePaymentGateway = (transactionType: PaymentTransactionType) => {
  const { data: marketplaceData } = useMarketplaceConfig();
  const paymentGateway = marketplaceData?.marketplaceConfig?.paymentGateway || PAYMENT_GATEWAY.KAPOPAY;

  const kapopayContext = useKapopay();
  const pay2localContext = usePay2Local(transactionType);
  const ligdiCashContext = useLigdiCash();
  const cryptoContext = useCrypto();

  const gatewayDataMap = useMemo(
    () => ({
      [PAYMENT_GATEWAY.KAPOPAY]: kapopayContext,
      [PAYMENT_GATEWAY.PAY_2_LOCAL]: pay2localContext,
      [PAYMENT_GATEWAY.LIGDICASH]: ligdiCashContext,
      [PAYMENT_GATEWAY.CRYPTO]: cryptoContext,
    }),
    [kapopayContext, pay2localContext, ligdiCashContext, cryptoContext]
  );

  const mutationContext = gatewayDataMap[paymentGateway];

  return { ...mutationContext, paymentGateway };
};
